import service from "@/store/services/dpa-account-service";

export const state = () => ({
  list: {},
  dpaAccount: {},
  meta: {},
  url: null,
});

export const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, dpaAccount) => {
    state.dpaAccount = dpaAccount;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
  SET_URL: (state, url) => {
    state.url = url;
  },
};

export const actions = {
  list({ commit, dispatch }, params = {}) {
    return service.list(params, this.$axios).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },

  get({ commit, dispatch }, params) {
    return service.get(params, this.$axios).then((dpaAccount) => {
      commit("SET_RESOURCE", dpaAccount);
    });
  },

  add({ commit, dispatch }, params) {
    return service.add(params, this.$axios).then((dpaAccount) => {
      commit("SET_RESOURCE", dpaAccount);
    });
  },

  update({ commit, dispatch }, params) {
    return service.update(params, this.$axios).then((dpaAccount) => {
      commit("SET_RESOURCE", dpaAccount);
    });
  },

  destroy({ commit, dispatch }, params) {
    return service.destroy(params, this.$axios);
  },
};

const getters = {
  list: (state) => state.list,
  listTotal: (state) => state.meta.page.total,
  dpaAccount: (state) => state.dpaAccount,
  url: (state) => state.url,
  dropdown: (state) => {
    return state.list.map((dpaAccount) => ({
      id: dpaAccount.id,
      name: `${dpaAccount.debit_issuer_number} ${dpaAccount.debit_data_center_code}`,
    }));
  },
};

const dpaAccounts = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default dpaAccounts;
